import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Dashboard from './components/dashboard';
import Video from './components/video';

export const config = {
  endpoint: `https://119e05d1-967c-4108-a5b4-5cc886123cab.mock.pstmn.io/v1`,
};

function App() {
  return (



    <div className="App">
      <Router>
          <Routes>         
            <Route path='/' element={<Dashboard />} />
            <Route path='/videos/:id' element={<Video />} />
          </Routes>
      </Router>
    </div>
  );
}

export default App;
